import { Text } from "@chakra-ui/react";

const Loader = () => {
  return <Text as="p">Loading questions...</Text>;
};

export default Loader;
